module.exports = __webpack_public_path__ + "officialStatic/img/pf1.6e29ca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/pf1.png
// module id = IyYt
// module chunks = 0